module.exports = __webpack_public_path__ + "static/features-slide5@2x-3f9f9dd10034c6ca6794b7bfce89919f.png";